/* eslint-disable global-require */
const { BaseSMFClient } = require('./base-smf-client');

// Got rid of anonymous function that checked browser and set smf-client
// Now ignoring string-smf-client and setting it straight to buffer-smf-client
// const SMFClient = require('./buffer-smf-client').BufferSMFClient;

const SMFClient = (() => {
  // Got rid of the inconsequential ifs for old IE versions in 2024 (again?)
  /* eslint-env shared-browser-node */
  return require('./buffer-smf-client').BufferSMFClient;
})();

SMFClient.SMF_CLIENTCTRL_LOGIN_FAKE_CORRELATIONTAG = BaseSMFClient.SMF_MAX_CORRELATION;

module.exports.SMFClient = SMFClient;
